import React, { createContext, useState, useEffect } from 'react';
import axios from "src/utils/AxiosConfig";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [validationMessages, setValidationMessages] = useState([]);

  useEffect(() => {
    const fetchUser = async () => {
      setLoading(true);
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const response = await axios.post('/api/users/bytoken');
          setUser(response.data);
          localStorage.setItem('user', JSON.stringify(response.data));
          setLoading(false);
        } catch (error) {
          setLoading(false);
          setValidationMessages(error.message);
        }
      } else {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const login = async (login_id, password, autoLogin) => {
    try {
        const errors = [];
        if (!login_id) errors.push({ message: 'User ID is required.' });
        if (!password) errors.push({ message: 'Password is required.' });

        if (errors.length > 0) {
          setValidationMessages(errors);
          return;
        }
        setLoading(true);
        const response = await axios.post('/api/login', {
          login_id,
          password,
        });
        setLoading(false);
        if(!response.data.status){
          errors.push({ message: response.data.message });
          if (errors.length > 0) {
            setValidationMessages(errors[0].message);
            return;
          }
        }
        const token = response.data.access_token;
        localStorage.setItem('token', token);
        setUser(response.data.user);
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0];
        window.location.href = `/scheduleList/${formattedDate}`;
      } catch (error) {
        setLoading(false);
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;
          const aggregatedErrors = Object.values(errors).flat();
          setValidationMessages(aggregatedErrors);
          return;
        }
        setValidationMessages(error?.message);

      }
  };

  const logout = async () => {
    try {
      const response = await axios.post('/api/logout');
    } catch (error) {

    }
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, validationMessages, setValidationMessages, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
